/* Vis Collor extras (16/10): barra do carrinho, envio no mesmo dia, compre junto, calculadora, rastreio. Sem dependencias. */
(function () {
  'use strict';
  if (window.__vcExtras) return;
  window.__vcExtras = true;

  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function brl(cents) { return BRL.format((cents || 0) / 100); }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- 1. Barra de frete gratis / descontos ---------- */
  function pctDe(total, f, d10, d20) {
    if (total >= d20) return 1;
    if (total >= d10) return (66.6 + (total - d10) * 33.4 / (d20 - d10)) / 100;
    if (total >= f) return (33.3 + (total - f) * 33.3 / (d10 - f)) / 100;
    return (total * 33.3 / f) / 100;
  }
  function pintarBarra(el, total) {
    var f = +el.dataset.frete, d10 = +el.dataset.d10, d20 = +el.dataset.d20, msg;
    if (total >= d20) msg = '🎉 Você ganhou <strong>20% OFF + frete grátis!</strong>';
    else if (total >= d10) msg = 'Você já tem <strong>10% OFF + frete grátis</strong>. Faltam <strong>' + brl(d20 - total) + '</strong> para <strong>20% OFF</strong>';
    else if (total >= f) msg = '<strong>Frete grátis garantido!</strong> Faltam <strong>' + brl(d10 - total) + '</strong> para <strong>10% OFF</strong>';
    else msg = 'Faltam <strong>' + brl(f - total) + '</strong> para <strong>FRETE GRÁTIS</strong>';
    var p = pctDe(total, f, d10, d20);
    el.dataset.total = total;
    el.classList.toggle('vc-fb--ok', total >= d20);
    var m = el.querySelector('[data-vc-fb-msg]'); if (m && m.innerHTML !== msg) m.innerHTML = msg;
    var fill = el.querySelector('[data-vc-fb-fill]'); if (fill) fill.style.setProperty('--vc-fb', p.toFixed(4));
    var bar = el.querySelector('[role=progressbar]'); if (bar) bar.setAttribute('aria-valuenow', Math.round(p * 100));
    [f, d10, d20].forEach(function (lim, i) {
      var mk = el.querySelector('[data-vc-fb-m="' + (i + 1) + '"]'); if (mk) mk.classList.toggle('is-on', total >= lim);
    });
  }
  var ultimoCarrinho = null, pedindo = null;
  function aplicarCarrinho(c) {
    ultimoCarrinho = c;
    var total = typeof c.items_subtotal_price === 'number' ? c.items_subtotal_price : c.total_price;
    document.querySelectorAll('[data-vc-frete]').forEach(function (el) { pintarBarra(el, total); });
    document.querySelectorAll('[data-vc-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
  }
  function atualizarCarrinho() {
    if (pedindo) return pedindo;
    pedindo = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(aplicarCarrinho)
      .catch(function () {})
      .then(function () { pedindo = null; });
    return pedindo;
  }
  var tAtual;
  function depois(ms) { clearTimeout(tAtual); tAtual = setTimeout(atualizarCarrinho, ms || 60); }
  ['shopify:cart:lines-update', 'shopify:cart:discount-update'].forEach(function (nome) {
    document.addEventListener(nome, function (e) {
      if (e && e.promise && e.promise.then) e.promise.then(function () { depois(30); }, function () { depois(30); });
      else depois(400);
    }, true);
  });
  document.addEventListener('cart:update', function () { depois(60); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) atualizarCarrinho(); });
  // Qualquer POST para /cart/... (add, change, update, clear) feito pelo tema ou por apps
  if (window.fetch && !window.fetch.__vc) {
    var fOrig = window.fetch;
    var fNovo = function (input, init) {
      var p = fOrig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var met = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (met !== 'GET' && /\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { depois(80); }, function () {});
      } catch (err) {}
      return p;
    };
    fNovo.__vc = true;
    window.fetch = fNovo;
  }
  // Barra/contador novos inseridos pelo tema (ex.: gaveta re-renderizada) recebem o valor certo
  if ('MutationObserver' in window) {
    new MutationObserver(function (lista) {
      var barra = false, envio = false;
      for (var i = 0; i < lista.length; i++) {
        var n = lista[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType !== 1) continue;
          if (n[j].matches('[data-vc-frete]') || n[j].querySelector('[data-vc-frete]')) barra = true;
          if (n[j].matches('[data-vc-envio]') || n[j].querySelector('[data-vc-envio]')) envio = true;
        }
      }
      if (envio) pintarEnvio();
      if (barra && ultimoCarrinho) aplicarCarrinho(ultimoCarrinho);
      if (barra) depois(120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 2. Envio no mesmo dia (seg-sex 9h-17h, Brasilia) ---------- */
  var FERIADOS = { // feriados nacionais (AAAA-MM-DD)
    '2026-11-02': 1, '2026-11-15': 1, '2026-11-20': 1, '2026-12-25': 1,
    '2027-01-01': 1, '2027-03-26': 1, '2027-04-21': 1, '2027-05-01': 1, '2027-09-07': 1, '2027-10-12': 1, '2027-11-02': 1, '2027-11-15': 1, '2027-11-20': 1, '2027-12-25': 1,
    '2028-01-01': 1, '2028-04-14': 1, '2028-04-21': 1, '2028-05-01': 1, '2028-09-07': 1, '2028-10-12': 1, '2028-11-02': 1, '2028-11-15': 1, '2028-11-20': 1, '2028-12-25': 1
  };
  var DIAS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
  var fmtSP = null;
  try { fmtSP = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); } catch (e) {}
  function agoraSP() {
    var d = new Date(), o = {};
    if (fmtSP) fmtSP.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    else { var u = new Date(d.getTime() - 3 * 3600000); o = { year: u.getUTCFullYear(), month: u.getUTCMonth() + 1, day: u.getUTCDate(), hour: u.getUTCHours(), minute: u.getUTCMinutes() }; }
    var y = +o.year, m = +o.month, dd = +o.day, h = +o.hour % 24, mi = +o.minute;
    var wd = new Date(Date.UTC(y, m - 1, dd)).getUTCDay();
    return { y: y, m: m, d: dd, h: h, mi: mi, wd: wd };
  }
  function chave(y, m, d) { return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d; }
  function diaUtil(y, m, d) { var wd = new Date(Date.UTC(y, m - 1, d)).getUTCDay(); return wd !== 0 && wd !== 6 && !FERIADOS[chave(y, m, d)]; }
  function textoEnvio() {
    var a = agoraSP(), min = a.h * 60 + a.mi, hojeUtil = diaUtil(a.y, a.m, a.d);
    if (hojeUtil && min < 17 * 60) {
      if (min < 9 * 60) return 'Compre agora e seu pedido é <strong>enviado HOJE!</strong>';
      var falta = 17 * 60 - min, hh = Math.floor(falta / 60), mm = falta % 60;
      var t = hh > 0 ? hh + 'h' + (mm < 10 ? '0' : '') + mm + 'min' : mm + 'min';
      return 'Compre nas próximas <strong>' + t + '</strong> e seu pedido é <strong>enviado HOJE!</strong>';
    }
    // proximo dia util
    var base = new Date(Date.UTC(a.y, a.m - 1, a.d)), n = 0;
    do { base = new Date(base.getTime() + 86400000); n++; } while (!diaUtil(base.getUTCFullYear(), base.getUTCMonth() + 1, base.getUTCDate()) && n < 15);
    var quando = n === 1 ? 'amanhã' : (base.getUTCDay() === 1 ? 'na segunda-feira' : 'na ' + DIAS[base.getUTCDay()] + ' (' + base.getUTCDate() + '/' + (base.getUTCMonth() + 1) + ')');
    return 'Compre agora e seu pedido é <strong>enviado ' + quando + '</strong>.';
  }
  function pintarEnvio() {
    var html = textoEnvio();
    document.querySelectorAll('[data-vc-envio-txt]').forEach(function (el) { if (el.innerHTML !== html) el.innerHTML = html; });
  }

  /* ---------- 3. Compre junto ---------- */
  function adicionar(variante, qtd) {
    var acts = window.Shopify && window.Shopify.actions;
    if (acts && acts.updateCart) {
      return acts.updateCart({ lines: [{ merchandiseId: String(variante), quantity: qtd || 1 }] }, { event: { context: 'standard-action' } })
        .then(function (r) { if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message); return r; });
    }
    return window.fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +variante, quantity: qtd || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'erro'); });
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      var gaveta = document.querySelector('theme-drawer#cart-drawer');
      if (!gaveta) return;
      return fetch(root + '?sections=cart-drawer-section', { credentials: 'same-origin' }).then(function (r2) { return r2.json(); }).then(function (j) {
        var html = j && j['cart-drawer-section'];
        var atual = document.getElementById('shopify-section-cart-drawer-section');
        if (html && atual) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var novo = tmp.querySelector('.cart-drawer__inner'), velho = atual.querySelector('.cart-drawer__inner');
          if (novo && velho) velho.replaceWith(novo);
        }
        if (gaveta.open) gaveta.open();
      }).catch(function () {});
    });
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-vc-cj-var]');
    if (!sel) return;
    var item = sel.closest('[data-vc-cj-item]'), btn = item && item.querySelector('[data-vc-cj-add]');
    if (btn) btn.dataset.variant = sel.value;
    var opt = sel.options[sel.selectedIndex], pr = item && item.querySelector('[data-vc-cj-preco]');
    if (pr && opt && opt.dataset.preco) pr.textContent = opt.dataset.preco;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vc-cj-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var txt = btn.querySelector('[data-vc-cj-txt]') || btn;
    btn.setAttribute('aria-busy', 'true'); btn.classList.remove('is-ok', 'is-erro'); txt.textContent = 'Adicionando…';
    adicionar(btn.dataset.variant, 1).then(function () {
      btn.classList.add('is-ok'); txt.textContent = 'Adicionado ✓'; depois(150);
    }).catch(function () {
      btn.classList.add('is-erro'); txt.textContent = 'Tente de novo';
    }).then(function () {
      btn.removeAttribute('aria-busy');
      setTimeout(function () { btn.classList.remove('is-ok', 'is-erro'); txt.textContent = 'Adicionar'; }, 3500);
    });
  });
  function complementosShopify() {
    document.querySelectorAll('[data-vc-cj-url]').forEach(function (sec) {
      var url = sec.getAttribute('data-vc-cj-url'); sec.removeAttribute('data-vc-cj-url');
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var novo = tmp.querySelector('[data-vc-cj][data-fonte="shopify"]');
        if (novo && novo.querySelectorAll('[data-vc-cj-item]').length >= 2) sec.innerHTML = novo.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- 4. Calculadora ---------- */
  function calc(box) {
    var inp = box.querySelector('[data-vc-calc-in]'); if (!inp) return;
    var q = Math.max(0, Math.min(500, parseInt(inp.value, 10) || 0));
    var eco = Math.max(0, (+box.dataset.pincel) - (+box.dataset.refil)) * q;
    var m = box.querySelector('[data-vc-calc-mes]'), a = box.querySelector('[data-vc-calc-ano]');
    if (m) m.textContent = brl(eco); if (a) a.textContent = brl(eco * 12);
  }
  document.addEventListener('input', function (e) { var b = e.target.closest && e.target.closest('[data-vc-calc]'); if (b) calc(b); });
  document.addEventListener('click', function (e) {
    var bt = e.target.closest && e.target.closest('[data-vc-calc-mais],[data-vc-calc-menos]'); if (!bt) return;
    var box = bt.closest('[data-vc-calc]'), inp = box.querySelector('[data-vc-calc-in]');
    var v = (parseInt(inp.value, 10) || 0) + (bt.hasAttribute('data-vc-calc-mais') ? 1 : -1);
    inp.value = Math.max(1, Math.min(500, v)); calc(box);
  });

  /* ---------- 5. Rastreio ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-vc-rastreio]'); if (!f) return;
    e.preventDefault();
    var inp = f.querySelector('[data-vc-rastreio-in]'), msg = f.querySelector('[data-vc-rastreio-msg]');
    var cod = (inp.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (cod.length < 8) { if (msg) msg.textContent = 'Confira o código: ele tem letras e números (ex.: AA123456789BR).'; inp.focus(); return; }
    if (msg) msg.textContent = '';
    var base = f.getAttribute('data-url') || 'https://www.melhorrastreio.com.br/rastreio/CODIGO';
    window.open(base.replace('CODIGO', encodeURIComponent(cod)), '_blank', 'noopener');
  });

  function iniciar() {
    pintarEnvio(); setInterval(pintarEnvio, 30000);
    complementosShopify();
    document.querySelectorAll('[data-vc-calc]').forEach(calc);
    if (document.querySelector('[data-vc-frete]')) atualizarCarrinho();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
